import { dNotify } from 'packages/lib/common-ui/notification/deduped-notify';
import {
  SampleGroup,
  sampleGroupZod,
} from 'packages/lib/api/annotations/contract/sample-group';
import { apiGet } from 'packages/lib/api/annotations/rest';
import useSWR, { SWRResponse } from 'swr';

const REFRESH_RATE_MS = 0; // disabled

export const useSampleGroupsForInstruction = (
  instructionToken: string | null | undefined
): SWRResponse<SampleGroup[]> =>
  useSWR<SampleGroup[]>(
    instructionToken
      ? `/sample-groups?instructionToken=${instructionToken}`
      : undefined,
    (url) =>
      apiGet<SampleGroup[]>(url, sampleGroupZod.array().parse).catch((err) => {
        dNotify.error({
          message: `Failed to fetch sample groups for this annotation instruction. Please report this error and include browser console outputs.`,
        });
        console.log(
          `Failed to fetch SampleGroups for instruction token: ${url}`
        );
        throw err;
      }),
    {
      refreshInterval: REFRESH_RATE_MS,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
